export const TESTNET_ENDPOINTS = [
  'https://testnet.rockerone.io',
  'https://tn1.protonnz.com',
  'https://proton-api-testnet.eosiomadrid.io',
  'https://proton-testnet.genereos.io',
  'https://proton-testnet.edenia.cloud',
  'https://testnet-api.alvosec.com',
  'https://testnet.proton.pink.gg',
  'https://test.proton.eosusa.news',
  'https://api-testnet-proton.eosarabia.net',
  'https://api.test.protonmt.com',
  'https://api-protontest.saltant.io',
  'https://api.testnet.totalproton.tech',
  'https://xpr.testnet.eosdublin.io',
  'https://api-protontest.nodeone.network:8344',
  'https://protontestnet.ledgerwise.io'
];
export const MAINNET_ENDPOINTS = [
  'https://proton.greymass.com',
  'https://api.protonchain.com',
  'https://proton.eosn.io',
  'https://proton.pink.gg',
  'https://proton.eosusa.news',
  'https://proton.eosdublin.io',
  'https://proton.eosamsterdam.net',
  'https://proton-mainnet.ledgerwise.io',
  'https://protonapi.cryptolions.io',
  'https://api.mainnet.protonmt.com',
  'https://api-protonmain.saltant.io',
  'https://api.mainnet.totalproton.tech',
  'https://xpr.proton.eosdublin.io',
  'https://api-proton.nodeone.network:8334',
  'https://protonapi.eosmetal.io',
  'https://mainnet.eosamsterdam.net'
]

export const TESTNET_CHAIN_ID = '71ee83bcf52142d61019d95f9cc5427ba6a0d7ff8accd9e2088ae2abeaf3d3dd';
export const MAINNET_CHAIN_ID = '384da888112027f0321850a169f737c33e53b388aad48b5adace4bab97f437e0';
